export default __webpack_public_path__ + "3a7a76525d98d25962ebcef6a840b70f.woff2";